import { Badge, Box, Heading, Text, VStack } from "@chakra-ui/react";
import { format, parseISO } from "date-fns";
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useTransactions } from "../context/TransactionsContext";
import {
  currentMonthTransactionList,
  formatEuro,
} from "../utils/helperFunctions";

// For Testing: Dummy-Daten zur Simulation von Transaktionen
/* const generateDummyTransactions = () => {
  const transactions = [];
  const today = new Date();

  for (let i = 0; i < 201; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() - i); // Erzeugt Daten für die letzten 100 Tage
    transactions.push({
      type: "expense",
      amount: Math.floor(Math.random() * 1000) + 1, // Zufälliger Betrag zwischen 1 und 100
      transactionListDate: date.toISOString(),
      date: date.toISOString(),
      description: `Expense ${i}`,
      category: "Sonstiges",
    });
  }

  return transactions;
}; */

export const DailyExpensesChart = () => {
  //For Testing
  /* const transactions = generateDummyTransactions(); */

  const { transactions } = useTransactions();
  const currentYear = new Date().getFullYear();

  const currentMonthTranscations = currentMonthTransactionList(transactions);

  const expensesByDay = currentMonthTranscations
    .filter((t) => t.type === "expense")
    .reduce((acc: Record<string, number>, t) => {
      const date = format(
        parseISO(t.transactionListDate || t.date),
        "dd.MM.yyyy"
      );
      acc[date] = (acc[date] || 0) + t.amount;
      return acc;
    }, {});

  const data = Object.entries(expensesByDay).map(([date, amount]) => ({
    date,
    Gesamtausgaben: amount,
  }));

  const highestExpenseSum = Math.max(
    ...data.map((daily) => daily.Gesamtausgaben)
  );
  const highestExpenseDate = data.find(
    (entry) => entry.Gesamtausgaben === highestExpenseSum
  )?.date;

  const calculateWidthForDailyExpenseAmount = () => {
    if (data.length > 10 && window.innerWidth <= 400) {
      return "130%";
    } else if (data.length < 10) {
      return "100%";
    } else if (data.length <= 20) {
      return "150%";
    } else if (data.length > 130 && data.length <= 200) {
      return "300%";
    } else if (data.length > 200) {
      return "1000%";
    }
  };

  return (
    <>
      {expensesByDay.length !== 0 ? (
        <>
          <VStack spaceY={3} mb={4}>
            <Heading size="lg" textAlign="center" mt={10}>
              Tagesausgaben {currentYear} | Summe pro Tag
            </Heading>
            <Badge colorScheme="red" fontSize="sm" bg="#e1e1e1">
              Höchste Tagesausgabe:{" "}
              <Text color="red">{formatEuro(highestExpenseSum)}</Text> -{" "}
              {highestExpenseDate}
            </Badge>
          </VStack>
          <Box
            p={4}
            borderRadius="md"
            overflowX="auto"
            width={{
              base: window.innerWidth,
              md: "768px",
              lg: "992px",
              xl: "1200px",
            }}
            height="350px"
          >
            <Box height="300px">
              <ResponsiveContainer
                width={calculateWidthForDailyExpenseAmount()}
                height="100%"
              >
                <BarChart
                  data={data}
                  margin={{ top: 20, right: 20, left: 40, bottom: 20 }}
                  barSize={30}
                >
                  {/*  <CartesianGrid strokeDasharray="3 3" /> */}
                  <XAxis dataKey="date" />
                  <YAxis tickFormatter={formatEuro} />
                  <Tooltip
                    formatter={(value: number) => `${formatEuro(value)}`}
                  />
                  <Bar dataKey="Gesamtausgaben" fill="#E53E3E" />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </Box>
        </>
      ) : (
        <p>Es gibt noch keine Tagesausgaben für den aktuellen Monat</p>
      )}
    </>
  );
};
